import { SearchOption } from '../common/table';
import { MainCategoryItem, PRODUCT_DISCOUNT_TYPE_V2, PRODUCT_STATUS_V2, ProductListRequest } from '../product';
import { CouponFindProductsResponseBodyProductsDto } from '../api/coupons';
import { DateRageType } from '../common/date';

export class CouponProductItemV2 {
  id: number;
  imageUrl: string;
  name: string;
  status: PRODUCT_STATUS_V2;
  originPrice: number;
  salesPrice: number;
  discountType: PRODUCT_DISCOUNT_TYPE_V2 | null;
  discountPrice?: number;
  discountRate?: number;
  discountPeriod: DateRageType;
  brandId: number;
  brandName: string;
  createDate: string;
  mainCategoryList: MainCategoryItem[];
  constructor(item: CouponFindProductsResponseBodyProductsDto) {
    this.id = item.id;
    this.imageUrl = item.imageUrl;
    this.name = item.name;
    this.status = item.status;
    this.originPrice = item.originPrice;
    this.salesPrice = item.salesPrice;
    this.discountType = item.discountType || null;
    this.discountPrice = item.discountPrice;
    this.discountRate = item.discountRate;
    this.discountPeriod = {
      startDate: item.discountStartDate || null,
      endDate: item.discountEndDate || null,
    };
    this.brandId = item.brand.id;
    this.brandName = item.brand.name;
    this.createDate = item.createDate;
    this.mainCategoryList = item.mainCategories;
  }
}

export type CouponProductListFilterOption = {
  productId?: number;
  productName?: string;
  brandName?: string;
  brandId?: number;
  mainCategoryId?: number | null;
};

export class CouponProductListOptionV2 implements SearchOption<CouponProductListFilterOption> {
  productId?: number;
  productName?: string;
  brandName?: string;
  brandId?: number;
  mainCategoryId?: number | null;
  page?: number;
  pageSize?: number;
  sort?: string[];

  constructor(option: ProductListRequest) {
    this.productId = option.id;
    this.productName = option.name;
    this.brandName = option.brandName;
    this.brandId = option.brandId;
    this.mainCategoryId = option.mainCategoryList;
    this.page = option.page;
    this.pageSize = option.pageSize;
    this.sort = option.sort;
  }
}
